import clsx from 'clsx';
import * as React from 'react';
import { useStyles } from './Button.styles';
import { ButtonStates } from './ButtonStates';

export interface IButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  tag?: 'div';
  variant?: 'primary' | 'secondary' | 'link' | 'ghost' | 'danger';
  size?: 'small' | 'medium';
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  icon?: React.ReactNode;
  onClick?(): void;
  _state?: typeof ButtonStates[number];
}

const Button: React.FC<IButtonProps> = ({
  icon,
  _state,
  disabled = _state === 'disabled',
  loading = _state === 'disabled',
  children,
  fullWidth = true,
  type = 'button',
  tag,
  variant = 'primary',
  size = 'medium',
  onClick,
}) => {
  const classes = useStyles();
  const Tag = tag === 'div' ? 'div' : 'button';
  const baseAttrs = {
    type,
    disabled: disabled || loading,
    onClick: disabled || loading ? undefined : onClick,
  };

  const attrs = {
    ...baseAttrs,
    ...(tag === 'div'
      ? { role: 'button', tabindex: disabled ? undefined : 0 }
      : {
          disabled,
        }),
  };

  return (
    <Tag
      className={clsx(
        classes.root,
        fullWidth && classes.fullWidth,
        icon && !children && classes.iconOnly,
        classes[variant],
        classes[size],
        _state && classes[_state],
        disabled && classes.disabled,
        loading && classes.loading,
      )}
      {...attrs}
    >
      <div className={classes.internal}>
        {icon && <div className={classes.icon}>{icon}</div>}
        {children && <div className={classes.label}>{children}</div>}
      </div>
    </Tag>
  );
};

export default Button;
